import { useQuery } from '@tanstack/react-query';

import { Service } from '@/infra/services/bera';
import { QUERY_KEYS } from '@/utils/query-keys';
import { GetBeraStepKeyResultMapper } from '@/core/mapper/bera';

import type { BeraReportV2StepKeyResult, BeraStepKeyReference } from '@/types/Bera';

interface GetBeraStepKeyResultListParams {
	bera_report_id: string;
	organization_id: string;
	company_id: string;
	step_keys: BeraStepKeyReference[];
}

export function useGetBeraStepKeyResultList(params: GetBeraStepKeyResultListParams) {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_BERA_STEP_KEY_RESULTS, params],
		queryFn: async () => {
			const requests = params.step_keys.map(async (step_key) => {
				const request = {
					organization_id: params.organization_id,
					company_id: params.company_id,
					bera_report_id: params.bera_report_id,
					custom_report_step_key_id: step_key.step_key_id
				};

				const response = await Service.getStepKeyResult(request);

				if (!response) {
					return null;
				}

				const row = new GetBeraStepKeyResultMapper(response, step_key).toDomain();

				return row;
			});

			const rows = await Promise.all(requests);
			const result = rows.filter((row): row is BeraReportV2StepKeyResult => !!row);

			return result;
		},
		enabled: !!params.bera_report_id && !!params.organization_id && !!params.company_id && !!params.step_keys.length
	});
}
